export function getUserFullName({ user }) {
    return `${user.first_name} ${user.last_name}`
}